'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (destination) {
  destination = (destination || '').trim();

  if (destination.indexOf('//') === 0 || destination.indexOf('http') === 0) {
    return '/';
  }

  return ('/' + destination).replace(/^\/*/, '/');
};